import { useEffect, useState } from 'react'

export function useAudioEnabled() {
  const [audioEnabled, setAudioEnabled] = useState<boolean>(() => {
    const storedValue = localStorage.getItem('audioEnabled')
    return storedValue ? JSON.parse(storedValue) : true
  })

  useEffect(() => {
    localStorage.setItem('audioEnabled', JSON.stringify(audioEnabled))
  }, [audioEnabled])

  return { audioEnabled, setAudioEnabled }
}
